// ===== Judge.me Carousel: kaunis-slider風ナビゲーション =====

function initJdgmKaunisSlider() {
  const wrapper = document.querySelector('.jdgm-carousel--done .jdgm-carousel__item-wrapper');
  if (!wrapper || wrapper.dataset.kaunisInit) return;
  wrapper.dataset.kaunisInit = 'true';

  restructureCarouselItems(wrapper);

  // Vue.jsによる再描画対策
  const observer = new MutationObserver(() => {
    restructureCarouselItems(wrapper);
  });
  observer.observe(wrapper, { childList: true, subtree: true });

  const items = wrapper.querySelectorAll('.jdgm-carousel-item');
  const carousel = wrapper.closest('.jdgm-carousel--done') || wrapper.parentElement;

  // コントロール挿入
  const controls = document.createElement('div');
  controls.className = 'jdgm-kaunis-controls';
  controls.innerHTML = `
    <button class="jdgm-kaunis-btn jdgm-kaunis-prev kaunis-prev" aria-label="Previous">
      <svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m4.32845 10.0708-4.18198-4.18194c-.195261-.19526-.195261-.51185 0-.70711l4.18198-4.181979c.19527-.195262.51185-.195262.70711 0 .19526.195259.19526.511849 0 .707109l-3.32843 3.32842s-.70713.4647-.00002 1l3.32845 3.32843c.19526.19526.19526.51185 0 .70707-.19526.1953-.51185.1953-.70711 0z" fill="currentColor" fill-rule="evenodd"/></svg>
    </button>
    <div class="jdgm-kaunis-progress"></div>
    <button class="jdgm-kaunis-btn jdgm-kaunis-next kaunis-next" aria-label="Next">
      <svg fill="none" height="11" viewBox="0 0 6 11" width="6" xmlns="http://www.w3.org/2000/svg"><path clip-rule="evenodd" d="m.853555.999962 4.181985 4.181978c.19526.19526.19526.51185 0 .70711l-4.181983 4.18195c-.195263.1953-.511845.1953-.511845 0-.1952631-.19523-.1952632-.51181 0-.70708l3.328431-3.32842s.70713-.4647.00002-1l-3.328453-3.32843c-.1952626-.19526-.1952627-.51185 0-.707108.195263-.195262.511845-.195262.707108 0z" fill="currentColor" fill-rule="evenodd"/></svg>
    </button>
  `;
  carousel.appendChild(controls);
  
  const prevBtn = controls.querySelector('.jdgm-kaunis-prev');
  const nextBtn = controls.querySelector('.jdgm-kaunis-next');
  const progressBar = controls.querySelector('.jdgm-kaunis-progress');

  function getVisibleItems() {
    return window.innerWidth <= 767 ? 1 : 4;
  }

  function initDots() {
    const visible = getVisibleItems();
    const dotCount = Math.ceil(items.length / visible);
    progressBar.style.setProperty('--dot-count', dotCount);
    progressBar.innerHTML = '';
    for (let i = 0; i < dotCount; i++) {
      const dot = document.createElement('span');
      dot.className = 'kaunis-dot' + (i === 0 ? ' active' : '');
      progressBar.appendChild(dot);
    }
  }

  function updateState() {
    const { scrollLeft, scrollWidth, clientWidth } = wrapper;
    const maxScroll = scrollWidth - clientWidth;
    prevBtn.disabled = scrollLeft <= 5;
    nextBtn.disabled = scrollLeft >= maxScroll - 5;

    const visible = getVisibleItems();
    const itemWidth = items[0]?.offsetWidth + 16;
    const dots = progressBar.querySelectorAll('.kaunis-dot');
    
    let currentIndex;
    if (scrollLeft >= maxScroll - 5) {
      currentIndex = dots.length - 1;
    } else {
      currentIndex = Math.round(scrollLeft / (itemWidth * visible));
    }
    
    dots.forEach((dot, i) => dot.classList.toggle('active', i <= currentIndex));
  }

  function step(dir) {
    const visible = getVisibleItems();
    const itemWidth = items[0]?.offsetWidth + 16;
    wrapper.scrollBy({ left: dir === 'next' ? itemWidth * visible : -(itemWidth * visible), behavior: 'smooth' });
  }

  prevBtn.addEventListener('click', () => step('prev'));
  nextBtn.addEventListener('click', () => step('next'));
  wrapper.addEventListener('scroll', updateState, { passive: true });
  
  window.addEventListener('resize', () => { 
    initDots(); 
    updateState(); 
  });

  let isDown = false;
  let startX;
  let scrollLeft;

  wrapper.addEventListener('mousedown', (e) => {
    isDown = true;
    wrapper.style.cursor = 'grabbing';
    wrapper.style.scrollSnapType = 'none';
    startX = e.pageX - wrapper.offsetLeft;
    scrollLeft = wrapper.scrollLeft;
  });

  wrapper.addEventListener('mouseleave', () => {
    isDown = false;
    wrapper.style.cursor = 'grab';
    wrapper.style.scrollSnapType = 'x mandatory';
  });

  wrapper.addEventListener('mouseup', () => {
    isDown = false;
    wrapper.style.cursor = 'grab';
    wrapper.style.scrollSnapType = 'x mandatory';
  });

  wrapper.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - wrapper.offsetLeft;
    const walk = (x - startX) * 2;
    wrapper.scrollLeft = scrollLeft - walk;
  });

  initDots();
  updateState();
}

function restructureCarouselItems(wrapper) {
  const items = wrapper.querySelectorAll('.jdgm-carousel-item');
  items.forEach(item => {
    if (item.dataset.kaunisRestructured) return;
    
    const productImage = item.querySelector('.jdgm-carousel-item__product-image');
    const reviewWrapper = item.querySelector('.jdgm-carousel-item__review-wrapper');
    const rating = item.querySelector('.jdgm-carousel-item__review-rating');
    const content = item.querySelector('.jdgm-carousel-item__review-content');
    const reviewerName = item.querySelector('.jdgm-carousel-item__reviewer-name');
    const productLink = item.querySelector('.jdgm-carousel-item__product');

    if (!productImage || !reviewWrapper) return;

    // ヘッダー作成
    const header = document.createElement('div');
    header.className = 'custom-carousel-header';
    
    const headerLeft = document.createElement('div');
    headerLeft.className = 'custom-carousel-header__left';
    headerLeft.appendChild(productImage);
    
    const headerRight = document.createElement('div');
    headerRight.className = 'custom-carousel-header__right';
    
    // デザイン通りの順序: 星 -> 名前 -> 商品名
    if (rating) headerRight.appendChild(rating);
    if (reviewerName) {
      reviewerName.style.order = "2"; // 念のためorder指定
      headerRight.appendChild(reviewerName);
    }
    if (productLink) {
      productLink.style.order = "3"; // 念のためorder指定
      headerRight.appendChild(productLink);
    }
    if (rating) rating.style.order = "1"; // 念のためorder指定
    
    header.appendChild(headerLeft);
    header.appendChild(headerRight);
    
    // ボディ作成
    const body = document.createElement('div');
    body.className = 'custom-carousel-body';
    if (content) body.appendChild(content);
    
    // 既存の中身をクリアして再配置
    while (reviewWrapper.firstChild) {
      reviewWrapper.removeChild(reviewWrapper.firstChild);
    }
    reviewWrapper.appendChild(header);
    reviewWrapper.appendChild(body);
    
    item.dataset.kaunisRestructured = 'true';
  });
}


// ===== Judge.me Review Widget: 商品詳細ページ用カスタマイズ =====

var _kaunisApplyTimer = null;

function findReviewWidget() {
  return document.querySelector('.jdgm-review-widget') || document.querySelector('.jm-review-widget');
}

function isWidgetReady(widget) {
  return widget && (
    widget.querySelector('.jm-review-widget-header') ||
    widget.querySelector('.jdgm-rev-widg')
  );
}

function needsCustomization(widget) {
  return widget && !widget.querySelector('.kaunis-title');
}

function initJdgmReviewWidget() {
  var widget = findReviewWidget();
  if (!widget) return;
  if (!isWidgetReady(widget)) return;

  widget.classList.add('kaunis-review-widget');
  applyAllWidgetCustomizations(widget);
}

function applyAllWidgetCustomizations(widget) {
  if (_kaunisApplyTimer) return;
  _kaunisApplyTimer = setTimeout(function() { _kaunisApplyTimer = null; }, 200);

  forceHideElements(widget);
  injectTitle(widget);
  injectCustomSummary(widget);
  moveActionButtons(widget);
  moveSortDropdown(widget);
  classifyStars(widget);
  restructureReviewItems(widget);
  updateLoadMoreButton(widget);

  reorderSummarySection(widget);

  // Vue.jsの事後更新対策: 少し遅延して再適用
  setTimeout(function() {
    forceHideElements(widget);
    injectTitle(widget);
    moveActionButtons(widget);
    classifyStars(widget);
    restructureReviewItems(widget);
    updateLoadMoreButton(widget);
    reorderSummarySection(widget);
  }, 200);
}

function reorderSummarySection(widget) {
  var summarySection = widget.querySelector('.jm-review-widget-header__summary-section');
  if (!summarySection) return;

  var customSummary = widget.querySelector('.custom-review-summary');
  var histogram = widget.querySelector('.jm-review-widget-header__star-rating-histogram');
  var actionWrapper = widget.querySelector('.custom-action-buttons-wrapper');

  if (customSummary && summarySection.firstChild !== customSummary) {
    summarySection.insertBefore(customSummary, summarySection.firstChild);
  }
  if (histogram && histogram.previousElementSibling !== customSummary) {
    if (customSummary) customSummary.after(histogram);
    else summarySection.insertBefore(histogram, summarySection.firstChild);
  }
  if (actionWrapper && actionWrapper.previousElementSibling !== histogram) {
    if (histogram) histogram.after(actionWrapper);
    else if (customSummary) customSummary.after(actionWrapper);
    else summarySection.appendChild(actionWrapper);
  }
}

function updateLoadMoreButton(widget) {
  var btn = widget.querySelector('.jm-load-more-pagination .jm-button');
  if (!btn) return;
  var textSpan = btn.querySelector('.jm-text');
  if (textSpan && textSpan.textContent !== 'READ MORE') {
    textSpan.textContent = 'READ MORE';
  }
}

function forceHideElements(widget) {
  var selectors = [
    '.jm-review-widget-header__filters-wrapper',
    '.jm-review-widget-header__title-and-rating',
    '.jm-review-widget-header__main-content'
  ];
  for (var i = 0; i < selectors.length; i++) {
    var el = widget.querySelector(selectors[i]);
    if (el) el.style.setProperty('display', 'none', 'important');
  }
}

function injectTitle(widget) {
  var header = widget.querySelector('.jm-review-widget-header');
  if (!header) return;

  if (!header.querySelector('.kaunis-title')) {
    var newTitle = document.createElement('p');
    newTitle.className = 'jm-review-widget-header__title kaunis-title';
    newTitle.textContent = 'Customer Reviews';
    header.insertBefore(newTitle, header.firstChild);
  }
}

function injectCustomSummary(widget) {
  if (widget.querySelector('.custom-review-summary')) return;

  var header = widget.querySelector('.jm-review-widget-header');
  var summarySection = widget.querySelector('.jm-review-widget-header__summary-section');
  if (!header || !summarySection) return;

  // レビューがない場合はサマリーの注入をスキップする
  if (widget.querySelector('.jm-no-reviews-state')) return;

  var widgetEl = widget.closest('[data-product-id]') || widget;
  var productId = widgetEl.getAttribute('data-product-id');
  if (!productId) return;

  var jdgmData = null;
  try {
    if (window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget) {
      jdgmData = window.jdgm.data.reviewWidget[productId] || window.jdgm.data.reviewWidget[Number(productId)];
    }
  } catch(e) {}

  if (!jdgmData) return;

  var avg = parseFloat(jdgmData.average_rating);
  var count = jdgmData.number_of_reviews;

  var customSummary = document.createElement('div');
  customSummary.className = 'custom-review-summary';
  customSummary.innerHTML =
    '<div class="custom-review-summary__text">お客様が語る、<br>確かな実感。</div>' +
    '<div class="custom-review-summary__stars">' + generateStarSvgs(avg) + '</div>' +
    '<div class="custom-review-summary__caption">5つ星中' + avg.toFixed(2) + 'つ星。' + count + '件のレビューに基づく</div>';

  summarySection.insertBefore(customSummary, summarySection.firstChild);

  var histogram = widget.querySelector('.jm-review-widget-header__star-rating-histogram');
  if (histogram && histogram.parentNode !== summarySection) {
    summarySection.appendChild(histogram);
  }
}

function moveActionButtons(widget) {
  var actionButtons = widget.querySelector('.jm-action-buttons');
  var summarySection = widget.querySelector('.jm-review-widget-header__summary-section');
  if (!actionButtons || !summarySection) return;

  if (!widget.querySelector('.custom-action-buttons-wrapper')) {
    var wrapper = document.createElement('div');
    wrapper.className = 'custom-action-buttons-wrapper';
    wrapper.appendChild(actionButtons);
    summarySection.appendChild(wrapper);
  } else {
    // 既にラッパーがある場合でも、中身がVueによって再描画された際のために再配置
    var existingWrapper = widget.querySelector('.custom-action-buttons-wrapper');
    if (actionButtons.parentNode !== existingWrapper) {
      existingWrapper.appendChild(actionButtons);
    }
  }
}

function moveSortDropdown(widget) {
  if (widget.querySelector('.custom-sort-section')) return;

  var sortFilter = widget.querySelector('.jm-sort-filter');
  if (!sortFilter) return;

  var sortSection = document.createElement('div');
  sortSection.className = 'custom-sort-section';
  sortSection.appendChild(sortFilter);

  var body = widget.querySelector('.jm-review-widget__body');
  if (body && body.parentNode) {
    body.parentNode.insertBefore(sortSection, body);
  }
}

function classifyStars(widget) {
  var ratings = widget.querySelectorAll('.jm-star-rating');
  for (var i = 0; i < ratings.length; i++) {
    var sr = ratings[i];
    var label = sr.getAttribute('aria-label') || '';
    var match = label.match(/(\d+)\s+out\s+of\s+(\d+)/);
    if (!match) continue;
    var filled = parseInt(match[1]);
    var icons = sr.querySelectorAll('.jm-star-rating__font-icon');
    for (var j = 0; j < icons.length; j++) {
      var icon = icons[j];
      if (j < filled) {
        if (!icon.classList.contains('kaunis-star-filled')) icon.classList.add('kaunis-star-filled');
        if (icon.classList.contains('kaunis-star-empty')) icon.classList.remove('kaunis-star-empty');
      } else {
        if (!icon.classList.contains('kaunis-star-empty')) icon.classList.add('kaunis-star-empty');
        if (icon.classList.contains('kaunis-star-filled')) icon.classList.remove('kaunis-star-filled');
      }
    }
    if (!sr.classList.contains('kaunis-stars-done')) sr.classList.add('kaunis-stars-done');
  }
}

function restructureReviewItems(widget) {
  var items = widget.querySelectorAll('.jm-review-item');
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var content = item.querySelector('.jm-review-item__content');
    var reviewerInfo = item.querySelector('.jm-reviewer-info');
    var body = item.querySelector('.jm-review-item__body');
    if (!content || !reviewerInfo || !body) continue;

    // 1. 日付要素の追加（未追加の場合のみ）
    if (!item.classList.contains('kaunis-date-done')) {
      var dateClusters = reviewerInfo.querySelectorAll('.jm-reviewer-info__details > .jm-cluster');
      var dateText = '';
      if (dateClusters.length >= 2) {
        var dateSpan = dateClusters[dateClusters.length - 1].querySelector('.jm-text');
        if (dateSpan) dateText = dateSpan.textContent.trim();
      }

      var starRow = content.querySelector('.jm-cluster:first-child');
      if (starRow && dateText && !starRow.querySelector('.custom-review-date')) {
        var dateEl = document.createElement('span');
        dateEl.className = 'custom-review-date';
        dateEl.textContent = formatRelativeDate(dateText);
        starRow.appendChild(dateEl);
        item.classList.add('kaunis-date-done');
      }
    }

    // 2. 画像コンテナの移動（contentの末尾へ）
    var thumbParent = item.querySelector('.jm-media-thumbnail-list__thumbnail');
    if (thumbParent) {
      var imgCluster = thumbParent.closest('.jm-cluster');
      if (imgCluster) {
        imgCluster.classList.add('kaunis-image-cluster');
        if (imgCluster.parentNode !== content) {
          content.appendChild(imgCluster);
        }
      }
    }

    // 3. ユーザー名の移動（bodyの末尾へ）
    // Vue.jsの再レンダリングで戻される可能性があるため、常にチェックして移動
    if (reviewerInfo.parentNode !== body || reviewerInfo.nextSibling !== null) {
      body.appendChild(reviewerInfo);
    }
    
    item.classList.add('kaunis-restructured');
  }
}

function formatRelativeDate(dateStr) {
  if (!dateStr) return '';
  var parts = dateStr.split('/');
  if (parts.length !== 3) return dateStr;
  var date = new Date(parseInt(parts[2]), parseInt(parts[0]) - 1, parseInt(parts[1]));
  var now = new Date();
  var diffMs = now - date;
  var diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (diffDays <= 0) return '今日';
  if (diffDays === 1) return '昨日';
  if (diffDays < 30) return diffDays + '日前';
  var diffMonths = Math.floor(diffDays / 30);
  if (diffMonths < 12) return diffMonths + 'ヶ月前';
  return Math.floor(diffDays / 365) + '年前';
}

function generateStarSvgs(rating) {
  var fullSvg = '<svg width="20" height="20" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.08188 0.275554C4.23657 -0.0918516 4.7634 -0.0918512 4.91809 0.275555L5.83103 2.44405C5.89628 2.59894 6.04373 2.70477 6.21298 2.71817L8.58267 2.90586C8.98417 2.93766 9.14697 3.43265 8.84107 3.69152L7.03563 5.21938C6.90668 5.32853 6.85033 5.49978 6.88973 5.66293L7.44133 7.94743C7.53478 8.33447 7.10858 8.64042 6.76483 8.43302L4.73603 7.20878C4.59111 7.12133 4.40886 7.12133 4.26395 7.20878L2.23514 8.43302C1.89139 8.64042 1.46518 8.33447 1.55863 7.94743L2.11023 5.66293C2.14963 5.49978 2.09331 5.32853 1.96436 5.21938L0.158877 3.69152C-0.147023 3.43265 0.0157805 2.93766 0.41728 2.90586L2.787 2.71817C2.95627 2.70477 3.10371 2.59894 3.16892 2.44405L4.08188 0.275554Z" fill="#B28575"/></svg>';
  var emptySvg = '<svg width="20" height="20" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.08188 0.275554C4.23657 -0.0918516 4.7634 -0.0918512 4.91809 0.275555L5.83103 2.44405C5.89628 2.59894 6.04373 2.70477 6.21298 2.71817L8.58267 2.90586C8.98417 2.93766 9.14697 3.43265 8.84107 3.69152L7.03563 5.21938C6.90668 5.32853 6.85033 5.49978 6.88973 5.66293L7.44133 7.94743C7.53478 8.33447 7.10858 8.64042 6.76483 8.43302L4.73603 7.20878C4.59111 7.12133 4.40886 7.12133 4.26395 7.20878L2.23514 8.43302C1.89139 8.64042 1.46518 8.33447 1.55863 7.94743L2.11023 5.66293C2.14963 5.49978 2.09331 5.32853 1.96436 5.21938L0.158877 3.69152C-0.147023 3.43265 0.0157805 2.93766 0.41728 2.90586L2.787 2.71817C2.95627 2.70477 3.10371 2.59894 3.16892 2.44405L4.08188 0.275554Z" fill="#DCD0C4"/></svg>';
  var fullCount = Math.floor(rating);
  var hasHalf = (rating % 1) >= 0.25;
  var html = '';
  for (var i = 0; i < 5; i++) {
    html += (i < fullCount || (i === fullCount && hasHalf)) ? fullSvg : emptySvg;
  }
  return html;
}


// ===== 初期化 =====

function waitForJdgm() {
  // カルーセル初期化
  if (document.querySelector('.jdgm-carousel--done')) {
    initJdgmKaunisSlider();
  } else {
    var carouselObserver = new MutationObserver(function() {
      if (document.querySelector('.jdgm-carousel--done')) {
        carouselObserver.disconnect();
        initJdgmKaunisSlider();
      }
    });
    carouselObserver.observe(document.body, { childList: true, subtree: true });
  }

  // レビューウィジェット: ポーリング方式で確実に検出・維持する
  setInterval(function() {
    var widget = findReviewWidget();
    if (!widget) return;
    if (!isWidgetReady(widget)) return;
    
    widget.classList.add('kaunis-review-widget');
    
    // カスタマイズが消えている場合は再適用
    if (needsCustomization(widget)) {
      applyAllWidgetCustomizations(widget);
    }
  }, 800);

  // 即時実行も試みる
  initJdgmReviewWidget();

  // Shopifyカスタマイズ画面でのセクション再読み込み対応
  document.addEventListener('shopify:section:load', function() {
    setTimeout(initJdgmReviewWidget, 500);
    setTimeout(initJdgmReviewWidget, 1500);
    setTimeout(initJdgmKaunisSlider, 500);
  });
}

// DOMContentLoadedが既に発火済みの場合にも対応
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', waitForJdgm);
} else {
  waitForJdgm();
}
